import { createAction } from 'redux-actions'

import { EXPORT } from 'constants/app-constants'
import c from 'constants/campaign-targets-constants'

// Fetch/update/import moved to TanStack Query; what remains is the running/paused selection (client state) + the export trigger.
export const addRunning = createAction(c.ADD_RUNNING)

export const addPaused = createAction(c.ADD_PAUSED)

export const clearSelection = createAction(c.CLEAR_SELECTION)

export const exportCampaignTargets = (campaignId: any) => (d: any) => {
  const url = `/management/campaigns/${campaignId}/targets/export?`
  d(createAction(EXPORT)({ url: `${__URL_API__}${url}` }))
}
